import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { action, toJS } from "mobx";
import { getDisplayDate } from '../../../../libs/date';
import { BASE_URL, MAP_CONFIG } from "../../../../config";
import LeafletMap from '../../../LeafletMap';
import _ from 'lodash';

@inject("stationStore", "stationImageStore", 'imageTagStore')
@observer
class Dashboard extends Component {
  interval;
  playing;

  state = {
    date_to: getDisplayDate(moment().endOf("day"), { format: "YYYY-MM-DD" }),
    date_from: getDisplayDate(moment().subtract(1, "month").startOf("day"), { format: "YYYY-MM-DD" }),
    albums: [],
    selectedAlbum: null,
    filter_date: 'date_taken',
    selectedTime: 0,
    albumImages: []
  };

  componentDidMount() {
    this.props.stationImageStore.fetchAlbums(this.props.params.id);

    this.fetchData();
  }

  fetchData = (e) => {
    if (e)
      e.preventDefault();

    const { date_from, date_to, filter_date } = this.state;
    const { params: { id } } = this.props;

    this.props.stationImageStore.fetchStationImages({
      station_id: id,
      date_from,
      date_to: getDisplayDate(date_to, { format: "YYYY-MM-DDTHH:mm:SS" }),
      filter_date
    }).then(images => {

      if (!!images && !!images.length) {
        const albumImages = [];
        let groupedByAlbum = _.groupBy(images, 'album_code');
        Object.keys(groupedByAlbum).forEach(album => {
          const latestImage = groupedByAlbum[album][groupedByAlbum[album].length - 1];
          albumImages.push(latestImage);
        });
        this.setState({ albumImages })
      }
    });
  };

  getImageMarkers = (images, center) => {
    // console.log(images, center, Math.sin(90 * Math.PI / 180), Math.cos(90 * Math.PI / 180))
    let markers = [], circles = [];
    if (!images || !images.length) return {
      markers,
      circles
    };
    // let imagesTemp = [...images, ...Object.assign([], toJS(images)), ...Object.assign([], toJS(images))]
    // imagesTemp[3].direction = 0
    // imagesTemp[3].direction_end = 0
    // imagesTemp[4].direction = 90
    // imagesTemp[4].direction_end = 90
    // imagesTemp[5].direction = 45
    // imagesTemp[5].direction_end = 45
    // imagesTemp[6].direction = 135
    // imagesTemp[6].direction_end = 135
    // imagesTemp[7].direction = 225
    // imagesTemp[7].direction_end = 225
    // imagesTemp[8].direction = 315
    // imagesTemp[8].direction_end = 315

    images.forEach((image, i) => {
      if (image.direction === image.direction_end) {
        const direction = image.direction;
        const round = num => Math.round(num * 1000) / 1000;

        let latOffset = round(0.02 * Math.cos(direction * Math.PI / 180)),
          lngOffset = round(0.02 * Math.sin(direction * Math.PI / 180));

        if (lngOffset !== 0) lngOffset *= 1.5;
        if (direction % 90 !== 0) {
          latOffset *= 1.5;
          lngOffset *= 1.5;
        }

        console.log(image.album_code, image.direction, image.direction_end, latOffset, lngOffset);

        markers.push({
          id: image.name,
          position: [center.lat + latOffset, center.lng + lngOffset],
          icon: `<div style="width: 300px;margin-top:-120px;margin-left: -150px">
            <div style="background: #3c8dbc;color: white;width: 300px;padding: 2px 0;text-align: center;margin-top: -5px;">${image.album_code}</div>
            <img width="300px" height="200px" style="margin: auto" src="${BASE_URL}/idaq-files/${image.source}"/>
            <div style="background: #3c8dbc;color: white;width: 300px;padding: 2px 0;text-align: center;margin-top: -5px;">${getDisplayDate(image.date_taken)}</div>
          </div>`
        });
        circles.push({ latLng: center, radius: 1000, startAngle: image.direction, stopAngle: image.direction_end });
      }
    });

    return {
      markers,
      circles
    }
  };

  render() {
    const { stationStore, params: { id } } = this.props;

    const station = stationStore.findById(id);
    if (!station || !station.latitude || !station.longitude) return null;

    const center = { lat: station.latitude, lng: station.longitude };
    const { markers, circles } = this.getImageMarkers(this.state.albumImages, center);
    // console.log(markers);

    return (
      <LeafletMap
        id={`station-${id}-image-dashboard`}
        center={center} zoom={14}
        markers={markers}
        height='80vh' width='100%'
        circle={circles}
        maxBounds={[[center.lat - 2, center.lng - 2], [center.lat + 2, center.lng + 2]]}
      />

    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/Station/Image/pages/Dashboard.js